export const timeout = (ms = 1000) => {
  let timeout = null

  return {
    set: callback => (timeout = setTimeout(callback, ms)),
    clear: () => clearTimeout(timeout)
  }
}
